module.exports = __webpack_public_path__ + "img/221121-bimistock-------2@1x.ae88db67.png";